import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { IHistoricoServicio } from '@/modules/Asistencial/interfaces/IHistoricoServicio'
import type { IHistoricoRecetario } from '@/modules/Asistencial/interfaces/IHistoricoRecetario'

export class HistoricoPacienteService extends BaseService<IHistoricoServicio> {
  constructor () {
    super({
      baseUrl: 'scheduling/patient-history/'
    })
  }

  /**
   * Servicios en los que se ha atendido el paciente (consultas tramitadas).
   */
  async getServicios (
    coppId: number
  ): Promise<AxiosResponse<IResponseApi<IHistoricoServicio[]>>> {
    return this.http.get<IResponseApi<IHistoricoServicio[]>>(
      `/services/${coppId}`
    ).catch(error => this.errorHandle(error))
  }

  /**
   * Historial de recetarios del paciente agrupado por atención.
   * @param coppId Id del paciente.
   * @param excludeCittId Atención a excluir (normalmente la atención actual).
   */
  async getRecetarios (
    coppId: number,
    excludeCittId?: number
  ): Promise<AxiosResponse<IResponseApi<IHistoricoRecetario[]>>> {
    return this.http.get<IResponseApi<IHistoricoRecetario[]>>(
      `/prescriptions/${coppId}`,
      { params: excludeCittId ? { excludeCittId } : {} }
    ).catch(error => this.errorHandle(error))
  }
}
